import React from "react";
import { connect } from "react-redux";
import {formatValueFromMapping} from "../../../utils/misc";
import {ReadOnlyCellContent} from "../cell/readOnlyCellContent";


const _ReadOnlyRow = ({ fields, fieldTypes, rowKey, row, valueMapping, isEditInterface }) => {

    // we need to add to the value mappings for any boolean fields to ensure they render correctly
    const ammendedValueMapping = Object.assign({}, valueMapping);
    fields.forEach((field) => {
        const fieldType = fieldTypes[field.name];
        // we want to give priority to any preexisting value mapping for the field.
        if ( fieldType === 'BooleanField' && !(field.name in valueMapping) ) {
            ammendedValueMapping[field.name] = {
                true: 'True',
                false: 'False',
            }
        }
    });

    return (
        <tr>
            { fields.map((field) => {
                return (
                    <td key={ rowKey + '.' + field.name }>
                        <ReadOnlyCellContent
                            cellData={ formatValueFromMapping(row[field.name], field.name, ammendedValueMapping) }
                            fieldType={ fieldTypes[field.name] }
                            extraClassNames={ isEditInterface ? `u-muted` : `u-whitespace-pre-wrap` }
                        />
                    </td>
                );
            })}
            { isEditInterface && <td></td> }
        </tr>
    );
};

const mapStateToProps = (state) => ({
    fields: state.immutableBaseData.fields,
    fieldTypes: state.immutableBaseData.fieldTypes,
    valueMapping: state.immutableBaseData.valueFormatterMapping,
    isEditInterface: state.immutableEditing.editingEnabled,
});

export const ReadOnlyRow = connect(mapStateToProps)(_ReadOnlyRow);
